class SlideToggle {
  constructor(el, opt) {
    this.el = el;
    this.toggleBtn = document.querySelector("." + this.el);
    this.toggleText = null;
    this.moreItems = null;
    this.isExpanded = false;

    if (this.toggleBtn) {
      this.init();
    }
  }

  init() {
    this.toggleText = document.querySelector(".gallery-toggle-text");
    this.moreItems = document.querySelectorAll(".gallery-more-item");
    this.moreItemsSp = document.querySelectorAll(".gallery-more-item-sp");
    this.iconFigure = this.toggleBtn.querySelector(".c-right-aro");

    // 必要な要素が存在しない場合は終了
    if (!this.toggleText || this.moreItems.length === 0) {
      return;
    }

    this.setupEventListeners();
    this.initSpItems();
  }

  // SP版の初期状態を設定
  initSpItems() {
    const isSp = window.innerWidth <= 767;
    if (isSp && this.moreItemsSp.length > 0) {
      this.moreItemsSp.forEach((item) => {
        item.classList.add("hidden");
        item.style.height = '0';
        item.style.opacity = '0';
        item.style.overflow = 'hidden';
      });
    }
  }

  setupEventListeners() {
    this.toggleBtn.addEventListener("click", (e) => {
      e.preventDefault();
      this.toggle();
    });
  }

  toggle() {
    this.isExpanded = !this.isExpanded;

    if (this.isExpanded) {
      // 展開する場合
      this.expand();
    } else {
      // 閉じる場合
      this.collapse();
    }
  }

  expand() {
    const isSp = window.innerWidth <= 767;
    
    // 展開する要素を決定
    const itemsToExpand = isSp 
      ? [...this.moreItemsSp, ...this.moreItems]
      : [...this.moreItems];
    
    // アコーディオン風に展開（全体で一斉に）
    itemsToExpand.forEach((item) => {
      // 最初にhiddenを外して要素を表示可能にする
      item.classList.remove("hidden");
      
      // 実際の高さを取得（display: blockで高さを正確に取得）
      item.style.height = 'auto';
      item.style.opacity = '0';
      item.style.overflow = 'hidden';
      const targetHeight = item.getBoundingClientRect().height;
      
      // 開始状態を設定（高さ0から）
      item.style.height = '0';
      
      // 強制的にレイアウトを再計算させる（reflow）
      item.offsetHeight;
      
      // 全体を一斉に展開
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          item.style.height = targetHeight + 'px';
          item.style.opacity = '1';
          
          // アニメーション完了後に高さをautoに戻す
          setTimeout(() => {
            item.style.height = 'auto';
            item.style.overflow = 'visible';
          }, 500);
        });
      });
    });

    // ボタンのテキストを変更
    this.toggleText.textContent = "CLOSE";

    // アイコンを-に変更
    if (this.iconFigure) {
      this.iconFigure.classList.add("is-minus");
    }

    // アニメーション完了後にスクロール
    setTimeout(() => {
      const firstMoreItem = this.moreItems[0];
      if (firstMoreItem) {
        const elementPosition = firstMoreItem.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - 100;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    }, 300);
  }

  collapse() {
    const isSp = window.innerWidth <= 767;
    
    // 閉じる要素を決定
    const itemsToCollapse = isSp 
      ? [...this.moreItemsSp, ...this.moreItems]
      : [...this.moreItems];
    
    // アコーディオン風に閉じる（全体で一斉に）
    itemsToCollapse.forEach((item) => {
      // まず現在の高さを取得して設定（autoの場合も正確に取得）
      const currentHeight = item.getBoundingClientRect().height;
      item.style.height = currentHeight + 'px';
      item.style.overflow = 'hidden';
      
      // 強制的にレイアウトを再計算させる（reflow）
      item.offsetHeight;
      
      // ブラウザに高さを認識させてからアニメーション開始
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          item.style.height = '0';
          item.style.opacity = '0';
          
          // アニメーション完了後にhiddenクラスを追加
          setTimeout(() => {
            item.classList.add("hidden");
            item.style.height = '';
            item.style.opacity = '';
            item.style.overflow = '';
          }, 500);
        });
      });
    });

    // ボタンのテキストを変更
    this.toggleText.textContent = "VIEW MORE";

    // アイコンを+に戻す
    if (this.iconFigure) {
      this.iconFigure.classList.remove("is-minus");
    }

    // GALLERYタイトルまでスクロール
    // アニメーション完了を待ってからスクロール
    setTimeout(() => {
      // GALLERYセクションのタイトルを探す
      const gallerySection = document.querySelector('.s-instagram');
      const galleryTitle = gallerySection ? gallerySection.querySelector('hgroup') : null;
      
      if (galleryTitle) {
        const titlePosition = galleryTitle.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = titlePosition - 100; // 100px上にオフセット

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    }, 300); // アニメーション時間に合わせて調整
  }
}